import { RegistrationMode } from "@timeedit/registration-schemas";
import { ButtonProps, Tag, Typography } from "@timeedit/ui-components";
import CheckOutlined from "@timeedit/ui-components/icons/CheckOutlined";
import WarningOutlined from "@timeedit/ui-components/icons/WarningOutlined";
import { ReactNode, useState } from "react";
import { ConflictNotification } from "../../Conflict";
import { StatusModal } from "../../StatusModal";
import { ButtonWithDescription } from "../ButtonWithDescription";
import { Translations } from "../types";
import { ENABLE_STUDENT_TO_DEALLCOATE } from "@timeedit/registration-shared";

type AllocatedToThisProps = {
  onDeallocate: () => void;
  clash: boolean;
  linkedIssue: boolean;
  description: ReactNode;
  translations: Translations;
  buttonProps: ButtonProps;
  mode?: RegistrationMode;
};
export function AllocatedToThis({
  clash,
  description,
  linkedIssue,
  onDeallocate,
  translations,
  buttonProps,
  mode,
}: AllocatedToThisProps): React.JSX.Element {
  const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false);
  const allowDeallocate = ENABLE_STUDENT_TO_DEALLCOATE || mode === "teacher";

  return (
    <>
      {allowDeallocate && (
        <>
          <StatusModal
            severity="Warning"
            open={deleteConfirmOpen}
            title={translations.deallocateConfirm}
            okText={translations.deallocate}
            closeIcon={false}
            onOk={() => {
              onDeallocate();
              setDeleteConfirmOpen(false);
            }}
            onCancel={() => setDeleteConfirmOpen(false)}
          />
          <ButtonWithDescription
            {...buttonProps}
            type="primary"
            description={description}
            icon={<CheckOutlined aria-hidden />}
            onClick={() => setDeleteConfirmOpen(true)}
            label={`${translations.registered}. ${translations.clickToDeregister}`}
          >
            {translations.registered}
          </ButtonWithDescription>
        </>
      )}
      {!allowDeallocate && (
        <div className="registered-wrap">
          <Tag.StatusTag showIcon state="Success" className="registered-tag">
            {translations.registered}
          </Tag.StatusTag>
          <Typography.Text>{description}</Typography.Text>
        </div>
      )}
      {clash && <ConflictNotification useText />}
      {linkedIssue && (
        <WarningOutlined
          className={"allocation-container--icon"}
          alt="Linked issue present"
        />
      )}
    </>
  );
}
